<script setup>
import { defineProps, ref } from "vue";
import ProductStageAvailability from "@/components/frontend/booking/ProductStageAvailability.vue";
import Modal from "@/components/frontend/ui/Modal.vue";
import BookingForm from "@/components/frontend/booking/BookingForm.vue";
import ProductsSearch from "@/components/frontend/ProductsSearch.vue";

const props = defineProps({
  availableFilters: {
    type: Object,
    default: function() {
      return {};
    }
  },
  baseFilters: {
    type: Object,
    default: function() {
      return {};
    }
  },
  urlProducts: {
    required: true
  },
  urlBooking: {
    required: true,
  },
  urlRegistration: {
    required: true,
    type: String,
  },
  isAvailable: {
    type: Function,
    required: true,
  },
  lifetimeInMinutes: {
    type: Number,
    default: 15,
  },
})


const selectedProduct = ref(null);
const onClickItem = (product) => {
  selectedProduct.value = product;
}

const booking = ref(null);
const onBookingSubmited = (b) => {
  selectedProduct.value = null;
  booking.value = b;
}


</script>

<template>
  <ProductsSearch
    :url-products="urlProducts"
    :base-filters="baseFilters"
    :available-filters="availableFilters"
    prevent-product-click
    @click-product="onClickItem"
  >
    <template #product-item-footer="{product}">
      <div class="pt-2 pb-3">
        <button class="btn btn-block btn-outline-primary"
                :disabled="!isAvailable(product)"
                type="button"
                @click.prevent="onClickItem(product)"
        >
          {{ isAvailable(product) ? $t('see availability') : $t('not available') }}
        </button>
      </div>
    </template>
  </ProductsSearch>

  <BookingForm
    :url-booking="urlBooking"
    :url-registration="urlRegistration"
    :lifetime-in-minutes="lifetimeInMinutes"
  >
    <template v-slot:default="{onSubmitBooking, disabledForm}">
      <Modal
        :show="!! selectedProduct"
        :title="selectedProduct ? selectedProduct.name : ''"
        @hide="selectedProduct = null"
        @hidePrevented="selectedProduct = null"
        @hidden="booking ? onSubmitBooking(booking) : null"
        size="lg"
      >
        <div v-if="selectedProduct" class="mb-2 mx-auto w-50">
          <img :src="selectedProduct.image_or_brand" :alt="selectedProduct.name" class="img-fluid">
        </div>
        <slot name="bookingModal" :product="selectedProduct" :onBookingSubmited="onBookingSubmited">
        </slot>
      </Modal>
    </template>
  </BookingForm>
</template>

<style scoped>

</style>